import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "./home.scss";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/loading/Loading";

const Products = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const [loading,setLoading] =useState(false)

  const columns = [
    { field: "sku", headerName: "LR Code", width: 150 },
    {
      field: "addedPhotos",
      headerName: "Image",
      width: 100,
      renderCell: (params) =>
        params.row.addedPhotos && params.row.addedPhotos.length > 0 ? (
          params.row.addedPhotos.map((item, index) => (
            <img
              key={index}
              src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item}`}
              alt={`Product ${index + 1}`}
              style={{
                marginTop: "10px",
                width: "30px",
                height: "30px",
                objectFit: "cover",
                marginRight: "5px",
                borderRadius: "50px",
                background: "lightgray",
                alignItems: "center",
              }}
            />
          ))
        ) : (
          <small>No Image</small>
        ),
    },
    { field: "title", headerName: "Title", width: 300 },
    // { field: "brand", headerName: "Brand", width: 200 },
    { field: "category", headerName: "Category", width: 200 },
    // {
    //   field: "discount",
    //   headerName: "Discount",
    // },
    {
      field: "price",
      headerName: "Price",
    },

  ];

  useEffect(() => {
    const getAllProduct = async () => {
      try {
        setLoading(true)
        const response = await axios.get("/get-all-products");

        // Map API response to DataGrid-compatible format
        const mappedProducts = response.data.map((item) => ({
          id: item._id, // DataGrid requires a unique 'id'
          sku: item.lrCode || "", // Your LR Code
          addedPhotos: item.proPhotos || [], // Array of images
          title: item.name || "",
          brand: item.brand || "",
          category: item.category || "",
          discount: item.discount || "",
          price: item.price || 0,
          weight: item.weight || "",
        }));

        setProducts(mappedProducts);
      } catch (error) {
        console.error("Error fetching products:", error);
      }finally{
        setLoading(false)
      }
    };

    getAllProduct();
  }, []);


  const handleCellClick =(id)=>{
    console.log(id)
  }



  return (
    <div className="main_wrp">
      <div className="main_page_wrp">
        <div className="head_wrp">
          <h5>
            {" "}
            All <em>Products</em>{" "}
          </h5>
        </div>
        <div className="main_body_wrp">
          {loading ? (
            <>
              <Loading />
            </>
          ) : (
            <DataGrid
              key={products.id}
              // rows={productData.filter((product) => product.status === "pending")}
              rows={products}
              columns={columns}
              pageSize={5}
              over
              disableRowSelectionOnClick
              initialState={{
                pagination: {
                  paginationModel: {
                    //pageSize:
                  },
                },
              }}
              getRowId={(row) => row.id}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              onCellClick={(params) => {
                navigate(`/update-product?proId=${params.row.id}`);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Products;
